const CONSTANTS = {
  YEARS: 'years',
  DAYS: 'days',
  HOURS: 'hours',
  MINUTES: 'minutes',
  SECONDS: 'seconds',
  SUCCESS: 0,
  NOAVAILABILITY: 8000,
  EMPTY_STATE: 1,
  LOCKED_STATUS: [-18, -19],
  PAYMENT_TYPE_KEY: 'paymentType',
  REGION_KRY: 'region',
  HOME_OFFER: 'home',
  PAID_BILL: '1',
  UN_PAID_BILL: '0',
  OS_TYPE: '0',
  APP_VERSION: '0',
  PREPAID: 1,
  POSTPAID: 2,
  MIX: 3,
  SNACK_BAR_SUCCESS: 'success',
  SNACK_BAR_ERROR: 'error',
  REMOVE_ACTION: 'Remove',
  ADD_ACTION: 'Add',
  IFRAME_KEY: 'Links',
  JAWWAL_APPS_KEY: 'JawwalApps',
  TERMS_AND_CONDITION_KEY: 'TermsConditions',
  TIPS_KEY: 'Traveling',
  TYPE_IMAGE_ALLOW: ['jpg', 'jpeg', 'png'],
  ENGLISH_REGEX: /[^A-Za-z0-9!@#$%&)(*<>":\^\&*\)~\[\].{}؟?_+=-\s]/g,
  ARABIC_REGEX: /[^\u0600-\u06FF0-9!@#$%&)(*<>":\^\&*\)~\[\].{}?؟_+=-\s]/g,
  API: '/api/',
  MAX_IMAGE_SIZE: '5000000',
  MAX_COMPRESSES_SIZE: '200000',
  RTL: 'rtl',
  LTR: 'ltr',
  NUMBER_REGEX: /^[0-9]+$/,
  ONLY_ENGLISH_LANG: /^[~`!@#$%^&*()_+=[\]\\{}|;':",.\/<>?a-zA-Z0-9-]+$/i,
}

export default CONSTANTS
